<div class="sidebar-container" [class.collapsed]="collapsed">
  <!-- Logo Section (hidden when logo is in drawer header) -->
  <div class="logo-section" *ngIf="!hideLogoSection">
    <div class="logo-wrapper">
      <div class="logo-circle">
        <i class="pi pi-briefcase"></i>
      </div>
    </div>
    <div class="logo-text-wrapper" *ngIf="!collapsed">
      <span class="logo-text">{{ 'layout.sidebar.brandName' | transloco }}</span>
      <p class="logo-subtitle">{{ brandSubtitleKey | transloco }}</p>
    </div>
  </div>

  <!-- Navigation Menu -->
  <nav class="sidebar-nav">
    <div class="nav-container">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menuItems, isRoot: true, depth: 0 }"></ng-container>
    </div>
  </nav>

  <ng-template #menuTpl let-items let-isRoot="isRoot" let-depth="depth">
    <ng-container *ngFor="let item of items">

      <!-- Category header (non-clickable group label) -->
      <ng-container *ngIf="item.isCategory && !collapsed">
        <div class="nav-category-header" [style.--depth]="depth">
          <span class="nav-category-label">
            {{ item.label | transloco }}
          </span>
        </div>
        <!-- Category children rendered directly (no expand/collapse) -->
        <ng-container *ngIf="item.children?.length">
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: item.children, isRoot: false, depth: depth }"></ng-container>
        </ng-container>
      </ng-container>

      <!-- Regular menu items (non-category) -->
      <ng-container *ngIf="!item.isCategory">
        <div class="nav-item"
             [class.active]="item.active"
             [class.has-children]="item.children?.length && !collapsed"
             [style.--depth]="collapsed ? 0 : depth">
          <div class="nav-link-wrapper">
            <button type="button"
                    class="nav-link"
                    pRipple
                    (click)="onMenuItemClick(item)"
                    [pTooltip]="collapsed ? (item.label | transloco) : ''"
                    tooltipPosition="right"
                    [showDelay]="300">
              <i *ngIf="item.icon" [class]="item.icon + ' nav-icon'"></i>
              <span class="nav-label" *ngIf="!collapsed">{{ item.label | transloco }}</span>
            </button>
            <button *ngIf="item.children?.length && !collapsed"
                    type="button"
                    class="nav-chevron-btn"
                    (click)="toggleExpand(item, $event)">
              <i class="pi chevron-icon"
                 [ngClass]="{ 'pi-chevron-down': item.expanded, 'pi-chevron-right': !item.expanded }"></i>
            </button>
          </div>
        </div>

        <!-- Children container (hidden when collapsed) -->
        <div class="nav-children" *ngIf="item.children?.length && item.expanded && !collapsed" [@slideDown]>
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: item.children, isRoot: false, depth: depth + 1 }"></ng-container>
        </div>
      </ng-container>

    </ng-container>
  </ng-template>

  <!-- Collapse Toggle Button (desktop only) -->
  <div class="collapse-toggle-section" *ngIf="!isMobile">
    <button type="button"
            class="collapse-toggle-btn"
            pRipple
            (click)="onCollapseToggle()">
      <i class="pi" [ngClass]="collapsed ? 'pi-angle-right' : 'pi-angle-left'"></i>
    </button>
  </div>

  <!-- User Profile Section -->
  <div class="user-profile-container">
    <button type="button"
            class="user-profile"
            pRipple
            (click)="collapsed ? onCollapseToggle() : toggleUserMenu()"
            [pTooltip]="collapsed ? userInfo.name : ''"
            tooltipPosition="right"
            [class.expanded]="userMenuExpanded">
      <div class="user-avatar">
        <p-avatar
          [label]="userInfo.avatar"
          size="large"
          shape="circle"
          styleClass="user-avatar-circle">
        </p-avatar>
      </div>
      <div class="user-info" *ngIf="!collapsed">
        <h4 class="user-name">{{ userInfo.name }}</h4>
        <span class="user-status">{{ 'layout.sidebar.userStatus.premium' | transloco }}</span>
      </div>
      <div class="user-chevron" *ngIf="!collapsed">
        <i class="pi chevron-icon"
           [ngClass]="{ 'pi-chevron-up': userMenuExpanded, 'pi-chevron-down': !userMenuExpanded }"></i>
      </div>
    </button>

    <!-- User menu options (hidden when collapsed) -->
    <div class="user-menu-options" *ngIf="userMenuExpanded && !collapsed" [@slideDown]>
      <button type="button"
              class="user-menu-item"
              pRipple
              (click)="onUserMenuAction('settings')">
        <i class="pi pi-cog"></i>
        <span>{{ 'layout.sidebar.userMenu.settings' | transloco }}</span>
      </button>
      <div class="user-menu-divider"></div>
      <button type="button"
              class="user-menu-item logout"
              pRipple
              (click)="onUserMenuAction('logout')">
        <i class="pi pi-sign-out"></i>
        <span>{{ 'layout.sidebar.userMenu.logout' | transloco }}</span>
      </button>
    </div>
  </div>
</div>
